import { Component, Input } from '@angular/core';
import { ClientNotificationHandlerService } from '@thehubz/client/core';

@Component({
  selector: 'sp-copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
  styleUrl: './copy-to-clipboard.component.scss',
})
export class CopyToClipboardComponent {
  @Input() copyText!: string;
  @Input() copyButtonLabel = $localize`Copy`;
  @Input() notificationText?: string;

  constructor(private readonly clientNotificationHandlerService: ClientNotificationHandlerService) {}

  notifyUser() {
    if (this.notificationText) {
      this.clientNotificationHandlerService.successNotification(this.notificationText);
    }
  }
}
